import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { getErrorBlob } from "helpers/extractError";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import {
  AUDIT_SETTLEMENTS_REPORT_LOADINGS,
  reportAuditSettlementsTypes,
} from "redux/reducers/Reports/reportAuditSettlements/types";

const { SET_AUDIT_SETTLEMENTS_REPORT_FILTERS } = reportAuditSettlementsTypes;
const { GET_REPORT } = AUDIT_SETTLEMENTS_REPORT_LOADINGS;

export const getReportAuditSettlementsAction = (
  { startDate, endDate, station, isPdf }
) => async (dispatch, getState) => {
  const token = getState().login.token || localStorage.getItem('crm-user');
  const params = {
    idStation: station.id,
    start: startDate,
    end: endDate,
    pdf: isPdf,
  };
  dispatch(startRequestComp(GET_REPORT));
  try {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/reports/settlements-aud`;
    const res = await axios.get(url, {
      headers: { authorization: token },
      responseType: "blob",
      params,
    });

    const format = isPdf ? "pdf" : "xlsx";
    saveAs(res.data, `Reporte_liquidaciones_auditoria_${station.name}_${startDate}_${endDate}.${format}`);
    dispatch(setSnackbar("Reporte descargado con éxito", "success"));
  } catch (err) {
    dispatch(setSnackbar(await getErrorBlob(err)));
  } finally {
    dispatch(stopRequestComp(GET_REPORT));
  }
};

export const setReportAuditSettlementsFilters = (key = "", value) => ({
  type: SET_AUDIT_SETTLEMENTS_REPORT_FILTERS,
  payload: { key, value }
});
